document.addEventListener('DOMContentLoaded', function () {
    const upsellCardsContainer = document.querySelector('.product-recommendations');

    const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            if (mutation.addedNodes.length) {
                const upsellCards = upsellCardsContainer.querySelectorAll('.card-upsell');
                if (upsellCards.length) {
                    setupColorSwatches(upsellCards);
                }
            }
        });
    });

    observer.observe(upsellCardsContainer, { childList: true, subtree: true });

    function setupColorSwatches(upsellCards) {
        upsellCards.forEach(card => {
            const colorSwatches = card.querySelectorAll('.color__swatch');
            const selectElement = card.querySelector('.select__select--color');

            colorSwatches.forEach(swatch => {
                swatch.addEventListener('click', function () {
                    const selectedValue = this.dataset.value;

                    // Simuler le clic sur l'option correspondante
                    const optionToSelect = Array.from(selectElement.options).find(option => option.dataset.value === selectedValue);
                    if (optionToSelect) {
                        // Changer la valeur du select
                        selectElement.value = optionToSelect.value;

                        // Déclencher l'événement change
                        const changeEvent = new Event('change', { bubbles: true, cancelable: true });
                        selectElement.dispatchEvent(changeEvent);
                    }

                    // Gérer les classes des swatches
                    this.classList.add('selected');
                    colorSwatches.forEach(otherSwatch => {
                        if (otherSwatch !== this) {
                            otherSwatch.classList.remove('selected');
                        }
                    });
                });
            });
        });
    }
});
